import { EditOutlined, SafetyCertificateFilled, SafetyCertificateOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { NameView } from './NameView';
import { NameEdit } from './NameEdit';
import { useIsAuthorized } from '../../../../../pages/common/roles/Roles';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';

export const Name = (props: { titleStatus: string, locationsIds:string[], shield: any}) => {

    const [edit, setEdit] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const [currentName, setCurrentName] = useState(props.titleStatus);
    const { t } = useTranslation();
    const isAuthorized = useIsAuthorized();    
    
    const handleMouseEnter = () => {
        setEditVisible(true);
    };

    const handleMouseLeave = () => {
        setEditVisible(false);
    };
      
    return (
        <div  
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{backgroundColor:editVisible ? 'var(--light-grey)' : ''}}>        

            <span style={{ textDecoration: "none", fontSize: "16px", color: "#3C4043", cursor:'pointer', fontWeight: 500 }} onClick={() => setEdit(true)}>
                {t('dictionary.name')}
                {editVisible && isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_INFO']) && <EditOutlined />}
            </span>
            {props.shield?.title === 'ALERT' && <NameView titleStatus={props.shield?.backup.title} strike={true} />}
            {
                !edit
                ?<NameView titleStatus={props.titleStatus!} />
                : <NameEdit 
                    isMassive={false} 
                    name={currentName} 
                    locationsIds={props.locationsIds} 
                    setEdit={setEdit} 
                    edit={edit} 
                    setCurrentName={setCurrentName}
                    
                />
            }
            
        </div>
    )
}
